import Vue from 'vue'
import App from './App'
import store from './vuex'
import router from './router'
import Vuetify from 'vuetify'
import 'vuetify/dist/vuetify.css'
import 'material-design-icons-iconfont/dist/material-design-icons.css'

import VueScrollTo from 'vue-scrollto'
import jspdf from 'jspdf'

Vue.config.productionTip = false

Vue.use(jspdf)

Vue.use(VueScrollTo, {
     container: "body",
     duration: 1000,
     easing: "ease",
     offset: -70,
     cancelable: true,
     onDone: false,
     onCancel: false,
     x: false,
     y: true
 })

Vue.use(Vuetify, {
  theme: {
    primary: '#00b7ff', // Azul
    secondary: '#212127', // Preto
    accent: '#82B1FF',
    error: '#FF5252',
    info: '#2196F3',
    success: '#4CAF50',
    warning: '#FFC107'
  }
})

/* eslint-disable no-new */
new Vue({
  el: '#app',
  router,
  store,
  render: h => h(App),
  created () {
    //firebase
  }
})



// WEBPACK FOOTER //
// ./src/main.js